import { withStyles } from "@material-ui/core";
import XAPPTooltip from "app/Core/Components/Tooltip/XAPPTooltip";
import XAPPComponent from "app/Core/Components/XAPPComponent/XAPPComponent";
import clsx from "clsx";
import React from "react";
import _ from "lodash";

const styles = () => ({
    root: {
        display: "flex",
        alignItems: "center",
        height: 21,
        borderRadius: 2,
        padding: "0 6px",
        fontSize: 11,
        backgroundColor: "rgba(0,0,0,.08);"
    },
    color: {
        width: 8,
        height: 8,
        borderRadius: "50%"
    }
});

class TagBullet extends XAPPComponent {

    render() {
        const { classes, itens = null, className } = this.props;
        if (!_.isNull(itens) && itens.length > 0) {
            return (
                <div className={clsx("flex flex-row w-full", className)}>
                    {itens.map((item, x) => (
                        <XAPPTooltip
                            key={x}
                            title={item.title}
                            placement={"top"}
                        >
                            <div className="flex justify-center mx-4 h-16 items-center">
                                <div className={classes.color} style={{ backgroundColor: item.color }} />
                            </div>
                        </XAPPTooltip>
                    ))}
                </div>
            );
        }
        else {
            return (
                <div />
            );
        }
    }
}


export default withStyles(styles)(TagBullet);
